import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { MARKETPLACES_ROUTES, HOME_ROUTES } from "@constants"
import {isSystemBusy, seller} from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import {useUserApp} from "@hooks";
import { TourProvider, TourTarget } from "@tour"
import { resetMarketplacesGeneral } from "./@signals"
import MarketplacesAuthorized from "./Authorized"
import MarketplacesGeneralFilters from "./Filters"
import MarketplacesMarketDetails from "./MarketDetails"
import MarketPlacesMarketPosition from "./MarketPosition"
import MarketplacesNumbers from "./Numbers"
import MarketplacesTopSellers from "./TopSellers"


export default function MarketplacesGeneralPage() {

    const { userUseRRSP } = useUserApp()

    const props = {
        head: `DIP Insight | ${MARKETPLACES_ROUTES.TITLE}`,
        title: MARKETPLACES_ROUTES.TITLE,
        subtitle: MARKETPLACES_ROUTES.SUBTITLE,
        isEmpty: false,
        filters: <MarketplacesGeneralFilters />,
        hasErrors: isSystemBusy.value,
        tourPageKey: "marketplacesGeneral"
    }

    useEffect(() => {
        return () => resetMarketplacesGeneral()
    }, [])

    return <PageWrapper {...props}>
        <Grid container spacing={4}>
            <Grid item xs={12} data-tour="mp-general-numbers">
                <MarketplacesNumbers />
            </Grid>
            {!!userUseRRSP && <Grid item xs={12} data-tour="mp-general-market-position">
                <MarketPlacesMarketPosition />
            </Grid>}
            <Grid item xs={7} sx={{ position: "relative", ".MuiPaper-root": { height: 1 } }}>
                <TourTarget name="mp-general-market-details" height={300} />
                <MarketplacesMarketDetails />
            </Grid>

            <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 1, justifyContent: 'space-between' }}>
                <div data-tour="mp-general-authorized">
                    <MarketplacesAuthorized />
                </div>
                <div style={{ position: "relative" }}>
                    <TourTarget name="mp-general-top-sellers" height={300} />
                    <MarketplacesTopSellers />
                </div>
            </Grid>
        </Grid>
    </PageWrapper>
}